const state = {
    activeModal: false
}

const mutations = {
    OPEN_MODAL (state) {
        state.activeModal = true
    },
    CLOSE_MODAL (state) {
        state.activeModal = false
    }
}

const actions = {
    openModal ({commit}) {
        commit('OPEN_MODAL')
    },
    closeModal ({commit}) {
        commit('CLOSE_MODAL')
    }
}

const getters = {
    modalOpened: (state) => {
        return state.activeModal
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}